import React from "react";
import get from 'lodash/get';

const AuthField = ({ record }) => {
    let value = get(record, "auth.identifier");
	if(!value) {
		value = get(record, "auth.ws");
		if(!value) value = "NOT_FOUND";
	}
    return value;
};

export default AuthField;